import React from "react";
import {connect} from "react-redux";
import {
  Datagrid,
  TextField,
} from "admin-on-rest";
import List from '../../../components/CRM/List';
import ActionBar from "../../../components/CRM/ActionBar";
import ActionMenu from "../../../components/CRM/ActionMenu";
import {refreshView as refreshViewAction} from "admin-on-rest";

class MessageTemplateDataListBase extends React.Component {
  
  render() {
    const props = {...this.props};

    return (
      <List
        title="resources.messageTemplates.name"
        {...props}
        actions={<ActionBar {...props} createButton={false} deleteButton={false}/>}
        sort={{field: "name", order: "ASC"}}
      >
        <Datagrid>
          <TextField label="resources.messageTemplates.fields.name" source="name" />
          <ActionMenu deleteButton={false}/>
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource],
  };
};

const MessageTemplateDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(MessageTemplateDataListBase);

export default MessageTemplateDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/MessageTemplates/MessageTemplateDataList.js